import { ListItems } from "../listItem/ListItem"
import style from "./sidebar.module.scss"
import { navigationData } from "../../../utils/helper"
import { Container } from "../../atoms/container/Container"

export const SideBar=()=>{
    return <Container className={style.wrapper}>
        <ListItems className={style.list} data={navigationData} />
    </Container>
}